import { BookOpen, Lightbulb, CalendarCheck, MessageSquare } from "lucide-react"

interface SignupBenefitsListProps {
  dogName: string
}

const BENEFITS = [
  {
    icon: BookOpen,
    title: "Full Personality Profile",
    description: (dogName: string) =>
      `A deep look at how ${dogName} thinks, learns and behaves.`,
  },
  {
    icon: Lightbulb,
    title: "Weekly Perspectives",
    description: (dogName: string) =>
      `Fresh insights each week tailored to ${dogName}'s personality.`,
  },
  {
    icon: CalendarCheck,
    title: "Personalised Tips",
    description: () => "Practical ideas and routines to support a happier life together.",
  },
  {
    icon: MessageSquare,
    title: "Ask Dynamo",
    description: (dogName: string) =>
      `Ask questions about ${dogName}'s behaviour and get guidance tailored just for them.`,
    isNew: true,
  },
] as const

export function SignupBenefitsList({ dogName }: SignupBenefitsListProps) {
  return (
    <section aria-labelledby="signup-benefits-heading">
      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-[var(--color-divider)]" aria-hidden />
        <h2
          id="signup-benefits-heading"
          className="shrink-0 text-center text-sm font-semibold text-[var(--color-text-primary)]"
        >
          Your free account unlocks:
        </h2>
        <div className="h-px flex-1 bg-[var(--color-divider)]" aria-hidden />
      </div>
      <ul className="mt-5 flex flex-col gap-4">
        {BENEFITS.map(({ icon: Icon, title, description, isNew }) => (
          <li key={title} className="flex gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[var(--color-ask-dynamo-surface)] text-[var(--color-ask-dynamo)]">
              <Icon size={18} aria-hidden />
            </span>
            <div className="min-w-0">
              <p className="flex flex-wrap items-center gap-2 text-sm font-semibold text-[var(--color-text-primary)]">
                {title}
                {isNew && (
                  <span className="inline-flex rounded-full bg-[var(--color-ask-dynamo)] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
                    New
                  </span>
                )}
              </p>
              <p className="mt-0.5 text-sm leading-relaxed text-[var(--color-text-secondary)]">
                {description(dogName)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
